import React from 'react';
import { visitorsOf } from '../../components/admin/dashboard/api';
import { useSummary } from '../../components/admin/dashboard/useSummary';
import { DashPage } from '../../components/admin/dashboard/DashPage';
import { SystemsCard } from '../../components/admin/dashboard/SystemsCard';
import { InsightsCard } from '../../components/admin/dashboard/InsightsCard';
import { LiveNowCard } from '../../components/admin/dashboard/LiveNowCard';
import { ChatListCard } from '../../components/admin/dashboard/ChatListCard';
import { PlacesCard } from '../../components/admin/dashboard/PlacesCard';

// The team's day-to-day view: systems, what's worth knowing and who's on the site now across the
// top, then live chats beside a globe of where visitors are. Traffic detail lives on Analytics.
// Design: docs/design-system/splitfin-handoff.md (the Splitfin Manager prototype, in Outpost colours).
const Dashboard: React.FC = () => {
  const s = useSummary();
  const { data } = s;
  return (
    <DashPage title="Dashboard" s={s} layout="home">
      <SystemsCard data={data} checks={s.checks} />
      <InsightsCard data={data} />
      <LiveNowCard data={data} />
      <ChatListCard data={data?.chat} rangeDays={s.days} />
      <PlacesCard v={visitorsOf(data)} loading={!data} />
    </DashPage>
  );
};

export default Dashboard;
